export default "https://cdn-static.gokick.com/assets/6e728f413af15b4cc1be7e84aa96f9132e166160/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";